import { ComponentProps } from "react";

const ArrowRightIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.0001 12.4999C17.9953 11.9738 17.7833 11.4708 17.4101 11.0999L13.1201 6.79995C12.9328 6.6137 12.6793 6.50916 12.4151 6.50916C12.1509 6.50916 11.8975 6.6137 11.7101 6.79995C11.6164 6.89291 11.542 7.00351 11.4912 7.12537C11.4405 7.24723 11.4143 7.37794 11.4143 7.50995C11.4143 7.64196 11.4405 7.77266 11.4912 7.89452C11.542 8.01638 11.6164 8.12698 11.7101 8.21995L15.0001 11.4999H5.00012C4.73491 11.4999 4.48055 11.6053 4.29302 11.7928C4.10548 11.9804 4.00012 12.2347 4.00012 12.4999C4.00012 12.7652 4.10548 13.0195 4.29302 13.207C4.48055 13.3946 4.73491 13.4999 5.00012 13.4999H15.0001L11.7101 16.7899C11.5218 16.9769 11.4155 17.231 11.4146 17.4964C11.4136 17.7618 11.5181 18.0166 11.7051 18.2049C11.8921 18.3932 12.1462 18.4996 12.4116 18.5005C12.677 18.5014 12.9318 18.3969 13.1201 18.2099L17.4101 13.9099C17.7857 13.5366 17.9979 13.0295 18.0001 12.4999Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowRightIcon;
